import DealerStatusCard from "../Dealers/DealerStatusCard";
import styles from "./ProdFilter.module.css";

const ProductionFilters = ({
  mode,
  selectedFilter,
  headerData,
  handleClick,
  getData,
  type,
}) => {
  return (
    <>
      <>
        {headerData?.map((s, index) => (
          <div
            key={s.status + index}
            className={`${styles.order_filter} ${
              mode ? styles.order_filter_dark : ""
            } ${
              s.status === selectedFilter
                ? mode
                  ? styles.order_filter_active_dark
                  : styles.order_filter_active
                : ""
            }`}
            onClick={async () => {
              if (s.status === selectedFilter) {
                await getData();
              } else {
                handleClick(s.status);
              }
            }}
          >
            <DealerStatusCard
              statusText={s.status}
              statusItemCount={s.count}
              statusAllCount={s.allCount}
              amount={s.amount}
              type={type}
            />
          </div>
        ))}
      </>
    </>
  );
};

export default ProductionFilters;
